/**
 * Suggest an event id from its title.
 *
 * A suggestion, not a derivation: the id is permanent, appears in every admin
 * URL and in `events/{eventId}/resources/...` storage paths, and two events
 * called "Annual Kickoff" cannot share one. So the form shows what this
 * produces and lets the operator overwrite it.
 *
 * Must satisfy the same shape firestore.rules and the CREATE_EVENT service
 * enforce: 3-63 chars, lowercase alphanumeric and hyphens, alphanumeric at both
 * ends. Returns "" when the title yields nothing usable, which the form treats
 * as "not ready to submit" rather than guessing.
 */
export function eventIdFromTitle(title: string): string {
  const slug = title
    .normalize("NFKD")
    // Strip combining marks so "Münster" reaches "munster" rather than losing
    // the vowel entirely.
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 63)
    // Slicing can leave a trailing hyphen that the pattern rejects.
    .replace(/-+$/, "");

  return slug.length >= 3 ? slug : "";
}
